module.exports = __webpack_public_path__ + "img/img.bc91c794.svg";